import React, { useEffect, useState } from "react";
import DropdownMenu from "./Dropdown.jsx";

const ColumnSelector = ({
  label = I18n.t("columns"),
  columns = [],
  selected,
  hiddenColumns,
  setSelected = () => {},
  setHiddenColumns = () => {},
  className = "",
  btnClassName,
  updateColumnsUrl,
}) => {
  const getNonPresentColumns = (cols) =>
    columns.filter((c) => !cols.includes(c.value)).map((c) => c.value);


  const [selectedColumns, setSelectedColumns] = useState(
    // Provide either 'selected' or 'hiddenColumns'
    selected || (hiddenColumns ? getNonPresentColumns(hiddenColumns) : [])
  );

  const toggleColumn = (value, checked) => {
    const newColumns = checked
      ? selectedColumns.concat([value])
      : selectedColumns.filter((c) => c != value);
    setSelectedColumns(newColumns);

    if (updateColumnsUrl) {
      jQuery.post(updateColumnsUrl, {
        columns: newColumns,
        hidden: columns.filter((c) => !newColumns.includes(c.value)).map((c) => c.value),
      });
    }
  };

  useEffect(() => {
    if (selected) {
      if (
        selected.some((s) => !selectedColumns.includes(s)) ||
        selectedColumns.some((sc) => !selected.includes(sc))
      ) {
        setSelectedColumns(selected);
      }
    } else if (hiddenColumns) {
      if (
        hiddenColumns.some((hc) => selectedColumns.includes(hc)) ||
        selectedColumns.some((sc) => hiddenColumns.includes(sc))
      ) {
        setSelectedColumns(getNonPresentColumns(hiddenColumns));
      }
    }
  }, [selected, hiddenColumns]);

  useEffect(() => {
    setSelected(selectedColumns);
    setHiddenColumns(getNonPresentColumns(selectedColumns));
  }, [selectedColumns]);

  return columns.length > 0 ? (
    <DropdownMenu
      btnType="default"
      label={
        <>
          <i className="fa fa-columns" /> {label} <i className="fa fa-caret-down" />
        </>
      }
      btnClass={btnClassName}
      containerClass={`column-selector d-inline-block ${className}`}
      hideOnClick={false}
    >
      {columns.map((c) => (
        <li key={c.value}>
          <label>
            <input
              type="checkbox"
              value={c.value}
              checked={selectedColumns.includes(c.value)}
              onChange={(e) => toggleColumn(c.value, e.target.checked)}
            />{" "}
            {c.label}
          </label>
        </li>
      ))}
    </DropdownMenu>
  ) : null;
};

export default ColumnSelector;
